import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { TenantService } from '../services/tenant.service';

/**
 * Resolves the '' route. On native, if the app relaunches after Android kills the
 * backgrounded process (e.g. after opening an external report in the system browser),
 * this sends the user back to the last screen they were on instead of onboarding —
 * as long as a tenant is configured and they're still logged in.
 */
export const rootGuard = async (): Promise<UrlTree> => {
  const router = inject(Router);

  if (!Capacitor.isNativePlatform()) {
    return router.parseUrl('/onboarding');
  }

  const tenant = inject(TenantService);
  const cfg = await tenant.loadSavedConfig();
  if (!cfg) {
    return router.parseUrl('/onboarding');
  }

  // The active profile's own token is the source of truth for multi-profile
  // sessions — falls back to the global key for the brief window right after
  // a fresh login before the profile upsert lands.
  const token = cfg.token ?? localStorage.getItem('token');
  const lastRoute = localStorage.getItem('lastRoute');
  if (token && lastRoute && lastRoute.startsWith('/ops')) {
    return router.parseUrl(lastRoute);
  }

  return router.parseUrl('/login');
};
